import React from 'react'
import { CardHeader, Heading, Text, Flex, Image, Tag } from '@pancakeswap/uikit'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'

const Wrapper = styled(CardHeader)<{ isFinished?: boolean; background?: string; isPromotedPool?: boolean }>`
  background: linear-gradient(111.68deg, #8708EE 0%, #7D8FF0 100%);
  border-radius: ${({ theme, isPromotedPool }) =>
    isPromotedPool ? '31px 31px 0 0' : `${theme.radii.card} ${theme.radii.card} 0 0`};
`

const StyledCardHeader: React.FC<{
  earningTokenSymbol: string
  stakingTokenSymbol: string
  isAutoVault?: boolean
  isFinished?: boolean
  isStaking?: boolean
  isPromotedPool?: boolean
}> = ({
  earningTokenSymbol,
  stakingTokenSymbol,
  isFinished = false,
  isAutoVault = false,
  isStaking = false,
  isPromotedPool = false,
}) => {
  const { t } = useTranslation()
  const poolImageSrc = isAutoVault
    ? `cake-cakevault.svg`
    : `${stakingTokenSymbol.toUpperCase()}.png`
    // : `${earningTokenSymbol}-${stakingTokenSymbol}.svg`.toLocaleLowerCase()
  const isCakePool = earningTokenSymbol === 'CAKE' && stakingTokenSymbol === 'CAKE'
  const background = isStaking ? 'bubblegum' : 'cardHeader'

  const MultiplierTag = styled(Tag)`
  margin-left: 4px;
  `
  const getHeadingPrefix = () => {
    if (isAutoVault) {
      // vault
      return t('Auto')
    }
    if (isCakePool) {
      // manual cake
      return t('Manual')
    }
    // all other pools
    return t('Earn')
  }

  const getSubHeading = () => {
    if (isAutoVault) {
      return t('Automatic restaking')
    }
    if (isCakePool) {
      return t('Earn CAKE, stake CAKE')
    }
    return t('Stake %symbol%', { symbol: stakingTokenSymbol })
  }

  const poolsMultiply = () => {
        if((stakingTokenSymbol === "VEMO" || stakingTokenSymbol === "VEMO-BNB LP") || (stakingTokenSymbol === "VEMO-USDT LP" || stakingTokenSymbol === "VSNT"))
        {
          return t('x 2')
        }
        return t('x 1')
  }

  return (
    <Wrapper isPromotedPool={isPromotedPool} isFinished={isFinished} background={background} style={{background:'#434853'}}>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex flexDirection="column">
          <Heading scale="lg">
            {getSubHeading()}
          </Heading>
          <Flex>
            <Text color={isFinished ? 'textDisabled' : 'textSubtle'}>
              {`${getHeadingPrefix()} ${earningTokenSymbol}`} 
            </Text>

            {earningTokenSymbol==='MTM'?  <img src='/mtm.png' alt={earningTokenSymbol} style={{marginLeft:'1rem',width:'40px'}}/>:''}

            {/* <MultiplierTag variant="secondary">
              {poolsMultiply()}
            </MultiplierTag> */}
          </Flex>
        </Flex>
        <Image src={`/images/tokens/${poolImageSrc}`} alt={earningTokenSymbol} width={64} height={64} />
      </Flex>
    </Wrapper>
  )
}

export default StyledCardHeader
